(() => {
  const drawer = document.querySelector('[data-hs-cart]');
  if (!drawer) return;
  const root = window.Shopify?.routes?.root || '/';
  const section = 'hs-cart-drawer';
  let busy = false;
  let adding = false;
  let returnFocus;
  let previousOverflow = '';
  const error = (message) => {
    const target = drawer.querySelector('[data-hs-cart-error]');
    target.textContent = message;
    target.hidden = !message;
  };
  const open = () => {
    if (drawer.open) return;
    returnFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    drawer.showModal();
    document.documentElement.style.overflow = 'hidden';
    drawer.querySelector('[data-hs-cart-close]').focus();
  };
  const render = (html) => {
    if (!html) throw new Error('Your item was added. Please open your cart to view it.');
    const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-hs-cart]');
    if (!fresh) throw new Error('We could not refresh your cart. Please try opening it again.');
    drawer.innerHTML = fresh.innerHTML;
    document.querySelectorAll('[data-cart-count]').forEach((badge) => {
      badge.textContent = fresh.querySelector('[data-hs-cart-content]').dataset.count;
    });
  };
  const refresh = async () => {
    const response = await fetch(root + '?sections=' + section, {headers: {Accept: 'application/json'}});
    if (!response.ok) throw new Error('We could not load your cart. Please try again.');
    render((await response.json())[section]);
  };
  const loading = (active) => {
    busy = active;
    drawer.toggleAttribute('data-adding', active && adding);
    if (active) drawer.setAttribute('aria-busy', 'true');
    else drawer.removeAttribute('aria-busy');
    const pending = drawer.querySelector('[data-hs-cart-pending]');
    if (pending) pending.hidden = !active;
    drawer.querySelectorAll('button:not([data-hs-cart-close])').forEach(control => { control.disabled = active; });
  };
  window.HSCart = {
    section,
    begin() {
      adding = true;
      error('');
      loading(true);
      open();
    },
    failed(message) {
      loading(false);
      adding = false;
      error(message);
    },
    async added(sections) {
      const wasAdding = adding;
      if (sections?.[section]) render(sections[section]);
      else await refresh();
      loading(false);
      adding = false;
      if (!wasAdding) open();
      else if (drawer.open) drawer.querySelector('[data-hs-cart-close]').focus({preventScroll: true});
    }
  };
  drawer.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    returnFocus?.focus({preventScroll: true});
  });
  document.addEventListener('click', async (event) => {
    const cartLink = event.target.closest('a[href]');
    if (!cartLink || event.defaultPrevented || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const url = new URL(cartLink.href, location.href);
    if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== (root + 'cart').replace(/\/$/, '') || url.search || url.hash) return;
    if (busy) { event.preventDefault(); return; }
    event.preventDefault();
    open();
    busy = true;
    drawer.setAttribute('aria-busy', 'true');
    try { await refresh(); } catch (err) { error(err.message); }
    finally { busy = false; drawer.removeAttribute('aria-busy'); }
  });
  drawer.addEventListener('click', async (event) => {
    if (event.target.closest('[data-hs-cart-close]')) { drawer.close(); return; }
    if (event.target === drawer) {
      const bounds = drawer.getBoundingClientRect();
      if (event.clientX < bounds.left || event.clientX > bounds.right) drawer.close();
      return;
    }
    const button = event.target.closest('[data-hs-cart-quantity]');
    if (!button || busy) return;
    const key = button.closest('[data-hs-cart-key]').dataset.hsCartKey;
    const quantity = Number(button.dataset.hsCartQuantity);
    const label = button.getAttribute('aria-label');
    busy = true;
    error('');
    drawer.setAttribute('aria-busy', 'true');
    drawer.querySelectorAll('button:not([data-hs-cart-close])').forEach((control) => { control.disabled = true; });
    try {
      const response = await fetch(root + 'cart/change.js', {
        method: 'POST', headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify({id: key, quantity, sections: section, sections_url: location.pathname})
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'We could not update your cart. Please try again.');
      if (result.sections?.[section]) render(result.sections[section]);
      else await refresh();
      const row = [...drawer.querySelectorAll('[data-hs-cart-key]')].find((element) => element.dataset.hsCartKey === key);
      const next = row && [...row.querySelectorAll('button')].find((element) => element.getAttribute('aria-label') === label);
      (next || drawer.querySelector('[data-hs-cart-close]')).focus({preventScroll: true});
    } catch (err) { error(err.message); }
    finally {
      busy = false;
      drawer.removeAttribute('aria-busy');
      drawer.querySelectorAll('button').forEach((control) => { control.disabled = false; });
    }
  });
})();
